
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/estimate/1-click/pcb",
      function () {
        return require("private-next-pages/estimate/1-click/pcb.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/estimate/1-click/pcb"])
      });
    }
  